// extracted by mini-css-extract-plugin
module.exports = {"copy":"v2-delivery-model_copy__RjJ76"};